import { graphql } from "@opensea/graphql"
import { useSubscription } from "@/hooks/use-subscription"

const mintProgressSubscription = graphql(`
  subscription DropMintProgressSubscription($collectionSlug: String!) {
    dropBySlug(slug: $collectionSlug) {
      __typename
      ... on Erc721SeaDropV1 {
        totalSupply
      }
      ... on Erc1155SeaDropV2 {
        tokenSupply {
          tokenId
          totalSupply
        }
      }
    }
  }
`)

export function useMintProgressSubscription(
  collectionSlug?: string,
  onUpdate?: ({
    totalSupply,
    totalSupplyPerToken,
  }: {
    totalSupply: number
    totalSupplyPerToken?: {
      tokenId: string
      totalSupply: number
    }[]
  }) => void,
) {
  useSubscription(
    {
      query: mintProgressSubscription,
      variables: {
        collectionSlug: collectionSlug ?? "",
      },
      pause: !collectionSlug,
    },
    data => {
      const drop = data.dropBySlug
      const newTotalSupply =
        drop?.__typename === "Erc1155SeaDropV2"
          ? drop.tokenSupply.reduce((acc, token) => {
              return acc + Number(token.totalSupply)
            }, 0)
          : Number(drop?.totalSupply)
      const newTotalSupplyPerToken =
        drop?.__typename === "Erc1155SeaDropV2"
          ? drop.tokenSupply.map(token => ({
              tokenId: String(token.tokenId),
              totalSupply: Number(token.totalSupply),
            }))
          : undefined

      onUpdate?.({
        totalSupply: newTotalSupply,
        totalSupplyPerToken: newTotalSupplyPerToken,
      })
    },
  )
}
